export const normalizeCategoryIdentity = (value = '') => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[-_\s]+/g, ' ');

export const buildAdminCategoryOptions = (partCategories = [], currentCategory = '') => {
  const options = [];
  const seen = new Set();

  for (const category of Array.isArray(partCategories) ? partCategories : []) {
    const key = String(category?.key || '').trim();
    const name = String(category?.name || '').trim();
    const identity = normalizeCategoryIdentity(key || name);
    if (!identity || seen.has(identity)) continue;
    seen.add(identity);

    const isEngineOil = identity === 'engine oil';
    options.push({
      value: isEngineOil ? 'engine-oil' : (name || key),
      label: isEngineOil ? 'Engine Oil' : (name || key),
      aliases: [key, name].filter(Boolean),
    });
  }

  const current = String(currentCategory || '').trim();
  const hasCurrent = options.some((option) =>
    option.aliases.some((alias) => normalizeCategoryIdentity(alias) === normalizeCategoryIdentity(current))
  );
  if (current && !hasCurrent) {
    options.unshift({ value: current, label: current, aliases: [current] });
  }
  return options;
};

export const getAdminCategorySelectValue = (options, currentCategory = '') => {
  const identity = normalizeCategoryIdentity(currentCategory);
  const match = options.find((option) =>
    option.aliases.some((alias) => normalizeCategoryIdentity(alias) === identity)
  );
  return match?.value || currentCategory;
};

export const isEngineOilCategory = (value) => normalizeCategoryIdentity(value) === 'engine oil';

export const getProductCategoryLabel = (value) => isEngineOilCategory(value) ? 'Engine Oil' : value;
